export default __webpack_public_path__ + "static/media/progress.aa83b691.svg";